import { create } from 'zustand';
import { AlertDialog } from '../components/dialogs/AlertDialog';
import { ImageDialog } from '../components/dialogs/ImageDialog';

const BASE_Z_INDEX = 1050;
const Z_INDEX_INCREMENT = 10;

export const useDialogStore = create((set, get) => ({
  dialogs: [],
  nextZIndex: BASE_Z_INDEX,

  openDialog: (component, props = {}) => {
    const { dialogs, nextZIndex } = get();
    const id = Date.now().toString();

    const newDialog = {
      id,
      component,
      props,
      zIndex: nextZIndex,
      isOpen: true
    };

    set({
      dialogs: [...dialogs, newDialog],
      nextZIndex: nextZIndex + Z_INDEX_INCREMENT
    });

    return id;
  },

  closeDialog: (id) => {
    set(state => ({
      dialogs: state.dialogs.map(dialog => 
        dialog.id === id ? { ...dialog, isOpen: false } : dialog
      )
    }));

    setTimeout(() => {
      set(state => ({
        dialogs: state.dialogs.filter(dialog => dialog.id !== id)
      }));
    }, 300);
  },

  closeTopDialog: () => {
    const { dialogs } = get();
    if (dialogs.length > 0) {
      const topDialog = dialogs[dialogs.length - 1];
      get().closeDialog(topDialog.id);
    }
  },

  closeAllDialogs: () => {
    set({ dialogs: [], nextZIndex: BASE_Z_INDEX });
  },
  
  alert: (message) => {
    get().openDialog(AlertDialog, {message: message, titleKey: 'alertTitle'});
  },

  warning: (message) => {
    get().openDialog(AlertDialog, {message: message, titleKey: 'warningTitle'});
  },
  
  info: (message) => {
    get().openDialog(AlertDialog, {message: message, titleKey: 'infoTitle'});
  },
  
  imageView: (data) => {
    get().openDialog(ImageDialog, {data: data});
  },
  
  confirm: (message, confirmAction, cancelAction) => {
    get().openDialog(AlertDialog, {message: message, onConfirm: confirmAction, onCancel: cancelAction, titleKey: 'warningTitle'});
  }
}));